import axiosInstance from "../mainService";

const newsService = {
    getNews(search, page, limit,company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data/m147_news/title/${sanitizedSearch}/${page}/${limit}/${company}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    totalAllNews(search, company_id) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/count-data/m147_news/title/${sanitizedSearch}/${company_id}`);
    },
    addNews(data) {
        return axiosInstance.post('/upload-data-news', data);
    },
    updateNews(data) {
        return axiosInstance.put('/update-data/m147_news/'+data.id, data);
    },
    deleteNews(id, news) {
        return axiosInstance.delete(`/delete-news/${id}/${news}`);
    }
}

export default newsService;